import { Per } from 'ep-bt-field-agent-proxy';

export class TallyEntryLineModel {
    constructor(id?: number, productID?: number, length?: number, width?: number,
        thickness?: number, quantity?: number, sellPrice?: number,
        inputPerID?: number, inputPerCode?: string, sellPerID?: number,
        sellPerCode?: string, priceIncludingTax?: boolean,
        imperial?: boolean, sellPer?: Per) {
        this.ID = id;
        this.ProductID = productID;
        this.Length = length;
        this.Width = width;
        this.Thickness = thickness;
        this.Quantity = quantity;
        this.SellPrice = sellPrice;
        this.InputPerID = inputPerID;
        this.InputPerCode = inputPerCode;
        this.SellPerID = sellPerID;
        this.SellPerCode = sellPerCode;
        this.PriceIncludingTax = priceIncludingTax;
        this.Imperial = imperial;
        this.Sell = sellPer;
    }

    public ID: number;

    /// <summary>
    /// this is for tally entry mapped to child product ID
    /// null any other type of for tally entry
    /// </summary>
    public ProductID: number;

    // public Tally Tally
    public Length: number;
    public Quantity: number;

    public Width: number;

    public Thickness: number;

    public Imperial: boolean;

    public Area: number;

    public SellPrice: number;

    public InputPerID: number;
    public InputPerCode: string;
    public SellPerID: number;
    public SellPerCode: string;
    public PriceIncludingTax: boolean; // it may belongs to QO rather then to tally line

    public Sell: Per;

}
